// Phase 43 — useMediaQuery hook (Plan 43-04).
// Reactive window.matchMedia wrapper used by the canvas shell (43-05) for
// desktop / tablet / phone reflow. See 43-RESEARCH.md "Research Area 9".

import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

    // Sync initial value in case SSR returned false and CSR now has a DOM
    setMatches(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
